import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/DemoPage.css";
import Navbar1 from "../Components/Header";
import Footer from "../Components/Footer";
import Loader from "../Components/Loader";
import image1 from "../Images/HotelManagement.png";
import image2 from "../Images/HospitalManagement.png";
import image3 from "../Images/EduTechApp.png";
import image4 from "../Images/SkillsTraining.png";

// Image Slider Component
const ImageSlider = ({ images, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="demo-image-slider">
      <div className="demo-slider-wrapper">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            loading="lazy"
            className={`demo-slider-image ${index === currentIndex ? 'slider-active' : ''}`}
          />
        ))}
      </div>
      
      {/* Slider Indicators */}
      <div className="slider-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

const DemoPage = () => {
  const [loading, setLoading] = useState(false);

  // Demo data for the four categories
  const demoCategories = [
    {
      id: 1,
      title: "Hotel Management System",
      description:
        "A unified platform designed to help restaurant owners and managers monitor performance, streamline operations, and make faster, data-driven decisions - all from a single dashboard.",
      images: [
        image1,
        "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop"
      ],
      demoLink: "https://devstackblitz.web.app/Webcrumbs/Create/FourModal/MultiplePage/MultiplePageShareView1?shareId=711939",
      features: [
        "Live revenue & order tracking",
        "Active table and staff monitoring",
        "Inventory alerts & system status",
        "Customer, kitchen, HR, and finance modules"
      ],
      alignment: "left"
    },
    {
      id: 2,
      title: "Hospital Management System",
      description:
        "An integrated digital platform designed to enhance patient experience while simplifying hospital operations. This demo highlights how hospitals can manage appointments, patient services, and clinical workflows through a secure, user-friendly interface.",
      images: [
        image2,
        "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop"
      ],
      demoLink: "https://devstackblitz.web.app/Webcrumbs/Create/FourModal/MultiplePage/MultiplePageShareView1?shareId=795927",
      features: [
        "Patient appointment booking & scheduling",
        "Centralized patient information management",
        "Integrated billing, pharmacy, and laboratory workflows",
        "Staff & resource scheduling"
      ],
      alignment: "right"
    },
    {
      id: 3,
      title: "Education Management System",
      description:
        "A purpose-built education platform designed to support inclusive classrooms and diverse learning needs. This demo highlights communication, emotional expression, and personalized learning tools that empower students, educators, and caregivers.",
      images: [
        image3,
        "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&h=600&fit=crop"
      ],
      demoLink: "https://devstackblitz.web.app/Webcrumbs/Create/FourModal/MultiplePage/MultiplePageShareView1?shareId=358061",
      features: [
        "Picture-based communication boards (AAC)",
        "Voice output tools",
        "Emotion tracking & expression",
        "Custom vocabulary management"
      ],
      alignment: "left"
    },
    {
      id: 4,
      title: "Skills Training & Solutions",
      description:
        "A modern digital learning platform designed to help learners acquire in-demand skills through structured courses, hands-on projects, and expert-led instruction. This demo showcases a complete learning journey - from course discovery to enrollment and career support.",
      images: [
        image4,
        "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop"
      ],
      demoLink: "https://devstackblitz.web.app/Webcrumbs/Create/FourModal/MultiplePage/MultiplePageShareView1?shareId=457943",
      features: [
        "Course catalog & enrollment flow",
        "Expert-led training programs",
        "Flexible, self-paced learning",
        "Career support & certification"
      ],
      alignment: "right"
    }
  ];

  const handleDemoClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <>
      <Loader />
      <div className="demo-page">
        <Navbar1 />
        
        {/* Hero Section */}
        <section className="demo-hero">
          <div className="container">
            <div className="demo-hero-content">
              <span className="demo-badge text-white">Explore Our Solutions</span>
              <h4 style={{color:"white"}} className="demo-hero-title">
                Experience Our Management Systems
              </h4>
              <p className="demo-hero-description">
                Discover powerful, cloud-based solutions designed to transform your business operations. 
                Explore interactive demos of our industry-leading management systems.
              </p>
            </div>
          </div>
        </section>

        {/* Demo Categories Section */}
        <section className="demo-categories">
          <div className="container">
            {demoCategories.map((category, index) => (
              <div
                key={category.id}
                className={`demo-category-card ${
                  category.alignment === "left" ? "content-left" : "content-right"
                }`}
              >
                <div className="demo-content">
                  <div className="demo-title-row">
                    <div className="demo-category-badge">
                      <span className="material-symbols-outlined">
                        {category.id === 1 && "hotel"}
                        {category.id === 2 && "local_hospital"}
                        {category.id === 3 && "school"}
                        {category.id === 4 && "workspace_premium"}
                      </span>
                    </div>
                    <h2 className="demo-category-title">{category.title}</h2>
                  </div>
                  <p className="demo-category-description">
                    {category.description}
                  </p>
                  
                  <ul className="demo-features-list">
                    {category.features.map((feature, idx) => (
                      <li key={idx} className="demo-feature-item">
                        <span className="material-symbols-outlined check-icon">
                          check_circle
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button
                    className="demo-button"
                    onClick={() => handleDemoClick(category.demoLink)}
                  >
                    <span className="material-symbols-outlined">play_circle</span>
                    View Demo UI
                  </button>
                </div>

                <div className="demo-image">
                  <ImageSlider images={category.images} interval={3000} />
                </div>
              </div>
            ))}
          </div>
        </section>
        
        <Footer />
      </div>
    </>
  );
};

export default DemoPage;
